<div class="container-aws-ses">
  <div class="aws-ses-scroll">
    <div class="label-lateral">
      <span class="label">Configuração de Envio</span>
    </div>

    <div class="container-aws-ses__content flex-direction-column gap-15">
      <app-slide-toggle-padrao
        [carregandoInfo]="carregando"
        [valor]="parametro.ativo"
        (changeValue)="parametro.ativo = $event">
      </app-slide-toggle-padrao>

      <app-form-field
        label="Endpoint"
        heightFormField="35px"
        [maxLengthFormFiles]="256"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametro.endpoint"
        (changeValue)="parametro.endpoint = $event">
      </app-form-field>

      <!-- <app-form-field
        label="Apelido"
        dica="Nome de exibição do remetente nos e-mails enviados"
        heightFormField="35px"
        [maxLengthFormFiles]="256"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametro.apelido"
        (changeValue)="parametro.apelido = $event">
      </app-form-field> -->

      <app-form-field
        label="Access Key"
        heightFormField="35px"
        [isSenha]="true"
        [maxLengthFormFiles]="512"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametro.accessKey"
        (changeValue)="parametro.accessKey = $event">
      </app-form-field>

      <app-form-field
        label="E-mail de Envio"
        heightFormField="35px"
        [maxLengthFormFiles]="256"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametro.emailRemetente"
        (changeValue)="parametro.emailRemetente = $event">
      </app-form-field>

      <div class="campos-limite">
        <app-form-field
          label="Limite por Hora"
          heightFormField="35px"
          type="number"
          [widthFormField]="'100%'"
          [carregandoInfo]="carregando"
          [value]="parametro.limiteHorario"
          (changeValue)="converterEAtribuirLimiteHorario($event)">
        </app-form-field>

        <app-form-field
          label="Limite por minuto"
          heightFormField="35px"
          type="number"
          [widthFormField]="'100%'"
          [carregandoInfo]="carregando"
          [value]="parametro.limiteMinuto"
          (changeValue)="converterEAtribuirLimiteMinuto($event)">
        </app-form-field>
      </div>

      <app-form-field
        label="Valor Unitário msg"
        heightFormField="35px"
        type="number"
        [textPrefix]="obterSimboloMoeda()"
        [step]="0.001"
        [min]="0"
        placeholder="0.000"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametro.valorUnitarioMsg"
        (changeValue)="atribuirValorUnitario($event)">
      </app-form-field>

      <app-select-one
        label="Moeda do valor por mensagem"
        widthFormField="100%"
        heightFormField="35px"
        campo="nome"
        [listaInput]="opcoesMoeda"
        [itemSelecionado]="obterMoeda()"
        (selecionarItem)="selecionarMoeda($event)">
      </app-select-one>
    </div>

    <div class="label-lateral secao-api">
      <span class="label">Conexão com api-azure-acs</span>
    </div>

    <div class="container-aws-ses__content flex-direction-column gap-15">
      <app-form-field
        label="Usuário"
        heightFormField="35px"
        [maxLengthFormFiles]="256"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametro.usuario"
        (changeValue)="parametro.usuario = $event">
      </app-form-field>

      <app-form-field
        label="Senha"
        heightFormField="35px"
        [isSenha]="true"
        [maxLengthFormFiles]="256"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametro.senha"
        (changeValue)="parametro.senha = $event">
      </app-form-field>
    </div>
  </div>

  <div class="aws-ses-rodape">
    <app-button-padrao
      width="100%"
      [label]="salvando ? 'Salvando...' : 'Salvar'"
      backgroundColor="var(--verde-padrao)"
      color="white"
      [disabled]="salvando"
      (buttonClick)="salvar()">
    </app-button-padrao>
  </div>
</div>
